<template>
  <nav class="menu">
    <div class="section section--title">
      <img class="logo" src="../assets/logo-blue.svg" alt="einfachonline">
      <AnimatedTitle class="title"></AnimatedTitle>
    </div>
    <div class="section section--sizes">
      <button v-for="size of allowedBoardSizes"
              :key="'size-' + size"
              @click="setBoardSize(size)"
              class="size-button"
              :class="getSizeButtonClasses(size)">
        {{ getNumberOfPairs(size) }}
      </button>
    </div>
    <div class="section section--start">
      <BigButton @click="startGame">
        Start playing
      </BigButton>
    </div>
  </nav>
</template>

<script>
  import { mapGetters, mapActions, mapMutations } from 'vuex';


  export default {
    name: 'Menu',
    props: {},
    computed: {
      ...mapGetters([
        'boardSize',
        'allowedBoardSizes',
      ]),
    },
    methods: {
      ...mapMutations([
        'setBoardSize',
      ]),
      ...mapActions([
        'startGame',
      ]),
      getSizeButtonClasses(size) {
        return (this.boardSize === size) ? ['size-button--active'] : [];
      },
      getNumberOfPairs(size) {
        return ((size * size) / 2);
      },
    },
  };
</script>

<style scoped lang="scss">
  @import "../config/styles/settings";
  @import "../config/styles/util";

  $active-size-button-scale: 1.25;

  .menu {
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: ($gutter * 2);
  }

  .section.section--logo {
  }

  .section.section--sizes {
    margin-top: ($gutter * 1.5);
  }

  .section.section--start {
    margin-top: ($gutter * 2);
  }

  .logo {
    height: 60px;
    max-width: 100%;
  }

  .size-button {
    @include reset-button;
    @include shadow-float;
    padding: ($gutter * 0.125);
    width: calc(3ch + #{($gutter * 0.125) * 2});
    height: calc(3ch + #{($gutter * 0.125) * 2});
    border-radius: $infinity;
    background-color: $blue-500;
    color: contrast($blue-500);
    font-weight: bold;
    transition: all 110ms ease-in-out;
  }

  .size-button.size-button--active {
    background-color: $purple-500;
    color: contrast($purple-500);
    transform: scale($active-size-button-scale);
    animation-name: wobble;
    animation-duration: 0.75s;
    animation-direction: normal;
    animation-iteration-count: 1;
    animation-timing-function: ease-in-out;
  }

  .size-button + .size-button {
    margin-left: ($gutter * 0.75);
  }

  .title {
    font-size: 6rem;
  }

  @keyframes wobble {
    from {
      transform: translate3d(0, 0, 0)
                 scale(1);
    }
    15% {
      transform: translate3d(-25%, 0, 0)
                 rotate3d(0, 0, 1, -5deg)
                 scale(#{$active-size-button-scale * 0.9});
    }
    30% {
      transform: translate3d(20%, 0, 0)
                 rotate3d(0, 0, 1, 3deg)
                 scale(#{$active-size-button-scale * 0.925});
    }
    45% {
      transform: translate3d(-15%, 0, 0)
                 rotate3d(0, 0, 1, -3deg)
                 scale(#{$active-size-button-scale * 0.95});
    }
    60% {
      transform: translate3d(10%, 0, 0)
                 rotate3d(0, 0, 1, 2deg)
                 scale(#{$active-size-button-scale * 0.975});
    }
    75% {
      transform: translate3d(-5%, 0, 0)
                 rotate3d(0, 0, 1, -1deg)
                 scale($active-size-button-scale);
    }
    to {
      transform: translate3d(0, 0, 0)
                 scale($active-size-button-scale);
    }
  }
</style>
